import { render, staticRenderFns } from "./importtagsmodal.vue?vue&type=template&id=16a42d4a&scoped=true"
import script from "./importtagsmodal.vue?vue&type=script&lang=js"
export * from "./importtagsmodal.vue?vue&type=script&lang=js"
import style0 from "./importtagsmodal.vue?vue&type=style&index=0&id=16a42d4a&prod&scoped=true&lang=css"
import style1 from "./importtagsmodal.vue?vue&type=style&index=1&id=16a42d4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a42d4a",
  null
  
)

export default component.exports